export const formatDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const addOneYear = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString().slice(0, 10);
};
